import axios from "axios";
import { accordianEnumArray, criteria } from "../constants";
import { showToast } from "../common/Toast";
import axiosInstance from "./AxiosInstance";

const fetchingBeforePackExpiry =  (payload) =>{
    const { usecaseProfileName, isEnable, periodicity, duration, totalNotification, tsHours, tsMinutes, endHours, endMinutes, messageText, landingPoints, usecaseDisplayName, startDays,weekDays,userSegmentCriteria,operators, method, usecaseId } = payload
    let body = {
        "usecaseProfileName": usecaseProfileName,
        "isEnable": isEnable,
        "periodicity": periodicity,
        "duration": duration,
        "totalNotification": totalNotification,
        "tsHours": tsHours,
        "tsMinutes": tsMinutes,
        "endHours": endHours,
        "endMinutes": endMinutes,
        "messageText": messageText,//"Dear user, your Super Plan subscription pack is set to expire on <EXPIRY_DATE>. Kindly recharge your pack to continue enjoying uninterrupted services.",
        "landingPoints": landingPoints, //["Point1", "Point2"],
        "usecaseDisplayName": usecaseDisplayName,//"Send notification before pack expiry."
        "startDays":startDays,
        "weekDays":weekDays,
        "userSegmentCriteria":userSegmentCriteria,
        "operators":operators
    }
    return (dispatch) => {
        try {
            if (method == "post") {
                axiosInstance.post('use-cases', body).then((res) => {
                    dispatch(beforePackExpiry(res.data));
                    showToast('Config Set Successfully', 'success');
                }).catch((error) => {
                    if(periodicity==="SPECIFIC_DAYS"){
                        showToast('Select specific day from the drop down', 'error');
                    }else {
                    showToast('Something Went Wrong !', 'error');
                    }
                })

            } else if (method == "put") {
                axiosInstance.put(`use-cases/${usecaseId}`, body).then((res) => {
                    dispatch(beforePackExpiry(res.data));
                    showToast('Config Updated Successfully', 'success');
                }).catch((error) => {
                    console.error("Error fetching data:", error);
                    if (!isEnable && method == "put"){
                        showToast('Please fill all th data first, Related to pack.', 'info');

                    }else{
                        if(periodicity==="SPECIFIC_DAYS"){
                            showToast('Select specific day from the drop down', 'error');
                        }else {
                        showToast('Something Went Wrong !', 'error');
                        }

                    }
                })

            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }
}


const filterAndUpdateData = (serverData,item) => {
    const existingData = serverData?.find((updatedItem) => updatedItem.usecaseProfileName === item.usecaseProfileName);

    // If the item is present in updatedData, return the updated item; otherwise, return the original item
    return existingData ? { ...item, ...existingData } : item;

  };

 const fetchingAllUseCase= ()=> {
    return (dispatch) => {
        try {
            axiosInstance.get('use-cases').then((res) => {

                const resultData = accordianEnumArray.map((item)=>{
                    return filterAndUpdateData(res.data,item)
                  });
                dispatch(getAllUseCase(resultData))
            }).catch((error) => {
                console.error("Error fetching data:", error);
                dispatch(getAllUseCase(accordianEnumArray))
            })
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }
}


const fetchingAllCriteria =()=>{
    return (dispatch) => {
        try {
            axiosInstance.get('segmentation/criteria').then((res) => {

                dispatch(getAllCriteria(res?.data?.data.filter(obj =>{
                    var temp = Object.assign({}, obj);
                      temp.criteria  =  capitalize(splitText(obj.criteria))
                      if(temp.isSuperCriteria===1){
                        return temp.criteria;
                      }
                })))
            }).catch((error) => {
                console.error("Error fetching data:", error);
                dispatch(getAllCriteria(criteria))
            })
        } catch (error) {
            console.error("Error fetching data:", error);
            dispatch(getAllCriteria(criteria))
        }
    }
}

const fetchingSubCriteriaOperator = (payload) =>{
    const {criteria1,criteria_count} = payload
    let body = {
        "criteria1":criteria1
      };
    return (dispatch) => {
        try {
            axiosInstance.post('segmentation/getSubCriteriaAndOperator',body).then((res) => {
               if(criteria_count==="c1"){
                dispatch(getSubCriteriaOperator(res.data))
               }else if(criteria_count==="c2"){
                dispatch(getSubCriteriaOperator2(res.data))
               }
            }).catch((error) => {
                console.error("Error fetching data:", error);
            })
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }
}

const fetchingSubCriteriaAndOperator = (payload) =>{
    const {criteria1,operator,operator_count} = payload
    let body = {
        "criteria1": criteria1,
        "operator":operator
    }
    return (dispatch) => {
        try {
            axiosInstance.post('segmentation/getSubCriteriaAndOperator',body).then((res) => {
                if(operator_count==="op1"){
                    dispatch(getSubCriteriaAndOperator(res.data))
                }else if(operator_count==="op2"){
                    dispatch(getSubCriteriaAndOperator2(res.data))
                }
            }).catch((error) => {
                console.error("Error fetching data:", error);
            })
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    }
}

function beforePackExpiry(packdata) {
    return {
        type: "BEFORE_PACK_EXPIRY",
        payload: packdata
    }
}

function getAllUseCase(packdata) {
    return {
        type: "GET_ALL_USE_CASE",
        payload: packdata
    }
}

function getAllCriteria(packdata) {
    return {
        type: "GET_ALL_CRITERIA",
        payload: packdata
    }
}

function getSubCriteriaOperator(packdata) {
    return {
        type: "GET_SUB_CRITERIA_OPERATOR",
        payload: packdata
    }
}

function getSubCriteriaAndOperator (packdata) {
    return {
        type:"GET_SUB_CRITERIA_AND_OPERATOR",
        payload:packdata
    }
}

function getSubCriteriaOperator2(packdata) {
    return {
        type: "GET_SUB_CRITERIA_OPERATOR2",
        payload: packdata
    }
}

function getSubCriteriaAndOperator2 (packdata) {
    return {
        type:"GET_SUB_CRITERIA_AND_OPERATOR2",
        payload:packdata
    }
}

function splitText(t) { return t.replace("_"," "); }
function capitalize(s){return s.toLowerCase().replace( /\b./g, function(a){ return a.toUpperCase(); } );};



export {
    fetchingBeforePackExpiry,
    fetchingAllUseCase,
    fetchingAllCriteria,
    fetchingSubCriteriaOperator,
    fetchingSubCriteriaAndOperator
}